import notify from 'devextreme/ui/notify';

function notifySuccess(msg) {
	notify(msg, 'success', 5000);
}

function notifyError(msg) {
	notify(msg, 'error', 5000);
}

export default {
	notifySuccess,
	notifyError
};
